import React from 'react';
import { RadioSetting, RadioSettingOption } from './RadioSetting';
import './RadioSettingGroup.css';

export interface RadioSettingGroupItem {
	settingId: string;
	title: string;
	description?: string;
	options: RadioSettingOption[];
	selectedValue: string;
	onChange: (value: string) => void;
	disabled?: boolean;
}

export interface RadioSettingGroupProps {
	settings: RadioSettingGroupItem[];
	className?: string;
}

export const RadioSettingGroup: React.FC<RadioSettingGroupProps> = ({
	settings,
	className = '',
}) => {
	return (
		<div className={`radio-setting-group ${className}`}>
			{settings.map((setting) => (
				<div key={setting.settingId} className="radio-setting-group-item">
					<RadioSetting
						settingId={setting.settingId}
						title={setting.title}
						description={setting.description}
						options={setting.options}
						selectedValue={setting.selectedValue}
						onChange={setting.onChange}
						disabled={setting.disabled}
						card={false}
					/>
				</div>
			))}
		</div>
	);
};
